$(document).ready(function () {
    $('input[name="websiteOption"]').on('change', function () {
        if ($('#hasWebsite').is(':checked')) {
            // Add 'required' attribute and show the URL input
            $('#website').attr('required', true);
            $('#website').closest('.form-group').show();
        } else if ($('#noWebsite').is(':checked')) {
            // Remove 'required' attribute and hide the URL input
            $('#website').removeAttr('required');
            $('#website').closest('.form-group').hide();
        }
    });

    // Initialize: Hide the URL input by default if "No" is pre-selected
    if ($('#noWebsite').is(':checked')) {
        $('#website').removeAttr('required');
        $('#website').closest('.form-group').hide();
    }
});